import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { finalize } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import { ErrorPopupComponent } from '../../../../core/components/pop-up/error-popup/error-popup.component';
import { LoadingPopupComponent } from '../../../../core/components/pop-up/loading-popup/loading-popup.component';
import { AccountVerificationStatusEnum } from '../../../../core/constants/role.constant';
import { LoginApiModel } from '../../../../core/models/auth.model';
import { ApiErrorResponseApiModel } from '../../../../core/models/general.models';
import { LoginService } from '../../../../core/services/api/login.service';
import { RolesService } from '../../../../core/services/helper/roles.service';
import { LocalStorageService } from '../../../../core/services/storages/local-storage.service';
import { FundingTypeEnum } from '../../../../features/web/funding-details/constants/funding-details.constant';
import { UserProfileStatusApiModel } from '../../../../features/web/user-profile/pages/user-profile/models/user-profile.model';
import { UserProfileService } from '../../../../features/web/user-profile/pages/user-profile/services/user-profile.service';
import { WalletApiModel } from '../../../../features/web/wallet/models/wallet.model';
import { WalletService } from '../../../../features/web/wallet/services/wallet.service';

@Component({
    selector: 'app-web-header',
    templateUrl: './web-header.component.html',
    styleUrl: './web-header.component.scss',
})
export class WebHeaderComponent implements OnInit {
    unreadNotification = 3;
    totalWalletBalance!: number;
    walletBalance!: WalletApiModel[];
    userDetails!: LoginApiModel;
    isIssuer = this.RolesService.isIssuer();
    isCorporate = this.RolesService.isCorporateInvestor();
    isIndividual = this.RolesService.isIndividualInvestor();
    isVerifiedIssuer = false;
    isVerifiedInvestor = false;
    AccountVerificationStatusEnum = AccountVerificationStatusEnum;
    FundingTypeEnum = FundingTypeEnum;
    userProfileStatus!: UserProfileStatusApiModel;

    constructor(
        protected localStorageService: LocalStorageService,
        protected loginService: LoginService,
        protected matDialog: MatDialog,
        protected RolesService: RolesService,
        protected walletService: WalletService,
        protected userProfileService: UserProfileService,
    ) {}

    ngOnInit(): void {
        this.userDetails = this.localStorageService.getLoginUser()!;

        this.getUserProfileStatus();

        if (!this.userDetails) {
            return;
        }

        this.getWalletDetails();
    }

    logout(): void {
        const loading = this.matDialog.open(LoadingPopupComponent, LoadingPopupComponent.getDialogConfig());

        this.loginService
            .logout()
            .pipe(
                finalize(() => {
                    loading.close();
                    window.location.href = environment.landingDomain;
                }),
            )
            .subscribe();
    }

    private getUserProfileStatus(): void {
        this.userProfileService.getUserProfileStatus().subscribe({
            next: (response) => {
                this.userProfileStatus = response;

                this.checkIssuerAccess();
            },
            error: (err) => {
                this.apiErrorHandler(err);
            },
        });
    }

    private checkIssuerAccess(): void {
        this.isVerifiedIssuer =
            this.isIssuer && this.userProfileStatus.issuerVerificationStatus === AccountVerificationStatusEnum.Verified;
        this.isVerifiedInvestor =
            (this.isCorporate || this.isIndividual) &&
            this.userProfileStatus.investorVerificationStatus === AccountVerificationStatusEnum.Verified;
    }

    private getWalletDetails(): void {
        this.walletService.getWalletDetailsV2().subscribe({
            next: (response) => {
                this.totalWalletBalance = response.reduce((total, wallet) => total + wallet.currentBalance, 0);
                this.walletBalance = response;
            },
            error: (err) => {
                this.apiErrorHandler(err);
            },
        });
    }

    private apiErrorHandler(err: ApiErrorResponseApiModel): void {
        const errorConfig = ErrorPopupComponent.getDialogConfig();
        errorConfig.data = {
            title: err.error.name,
            message: err.error.messages[0].message,
            showButton: true,
        };

        this.matDialog.open(ErrorPopupComponent, errorConfig).afterClosed();
    }
}
